import { defineMessages } from 'react-intl'

export default defineMessages({
  cannotBeBlankOrNullfirst: {
    id: 'cannotBeBlankOrNullfirst',
    defaultMessage: 'First name cannot be empty',
  },
  cannotBeBlankOrNulllast: {
    id: 'cannotBeBlankOrNulllast',
    defaultMessage: 'Last name cannot be empty',
  },
  cannotBeBlankOrNullfarmName: {
    id: 'cannotBeBlankOrNullfarmName',
    defaultMessage: 'Farm name cannot be empty',
  },
  cannotBeBlankOrNullemail: {
    id: 'cannotBeBlankOrNullemail',
    defaultMessage: 'Email cannot be empty',
  },
  cannotBeBlankOrNulladdress: {
    id: 'cannotBeBlankOrNulladdress',
    defaultMessage: 'Address cannot be empty',
  },
  cannotBeBlankOrNullcity: {
    id: 'cannotBeBlankOrNullcity',
    defaultMessage: 'City cannot be empty',
  },
  cannotBeBlankOrNullpostalCode: {
    id: 'cannotBeBlankOrNullpostalCode',
    defaultMessage: 'Postal code cannot be empty',
  },
  cannotBeBlankOrNullprovince: {
    id: 'cannotBeBlankOrNullprovince',
    defaultMessage: 'Province cannot be empty',
  },
  cannotBeBlankOrNullphone: {
    id: 'cannotBeBlankOrNullphone',
    defaultMessage: 'Phone number cannot be empty',
  },
  cannotBeBlankOrNullusername: {
    id: 'cannotBeBlankOrNullusername',
    defaultMessage: 'Username cannot be empty',
  },
  cannotBeBlankOrNullpassword: {
    id: 'cannotBeBlankOrNullpassword',
    defaultMessage: 'Password cannot be empty',
  },
  passwordsMustBeAtLeast6CharactersLong: {
    id: 'passwordsMustBeAtLeast6CharactersLong',
    defaultMessage: 'Passwords must be at least 6 characters long',
  },
  enterAValidEmailAddress: {
    id: 'enterAValidEmailAddress',
    defaultMessage: 'Please enter a valid email address',
  },
  userWithEmailAlreadyExists: {
    id: 'userWithEmailAlreadyExists',
    defaultMessage: 'Email already exists',
  },
  userAlreadyExists: {
    id: 'userAlreadyExists',
    defaultMessage: 'Username already exists',
  },
  emailAlreadyExistsMessage: {
    id: 'emailAlreadyExistsMessage',
    defaultMessage:
      'The email address you entered is already used on another account. ' +
      ' Would you like us to email you your login info or create a new account?',
  },
  passwordResetEmailSent: {
    id: 'passwordResetEmailSent',
    defaultMessage:
      'An email with instructions for resetting your password has been sent! ' + 'Please check your inbox shortly.',
  },
  'rgstrtn.sign_up_now': {
    id: 'rgstrtn.sign_up_now',
    defaultMessage: 'Sign Up Now!',
  },
  'rgstrtn.user_creation_success': {
    id: 'rgstrtn.user_creation_success',
    defaultMessage: 'User Creation Successful',
  },
  'rgstrtn.required_information': {
    id: 'rgstrtn.required_information',
    defaultMessage: 'Required Information',
  },
  'rgstrtn.reminder_order': {
    id: 'rgstrtn.reminder_order',
    defaultMessage: 'Remember: Order your supplies from the Order Supplies tab after creating your account.',
  },
  'rgstrtn.us_customary': {
    id: 'rgstrtn.us_customary',
    defaultMessage: 'US Customary',
  },
  'rgstrtn.metric': {
    id: 'rgstrtn.metric',
    defaultMessage: 'Metric',
  },
  'rgstrtn.default_units': {
    id: 'rgstrtn.default_units',
    defaultMessage: 'Default Units',
  },
  'rgstrtn.phone': {
    id: 'rgstrtn.phone',
    defaultMessage: 'Phone',
  },
  'rgstrtn.city': {
    id: 'rgstrtn.city',
    defaultMessage: 'City',
  },
  'rgstrtn.address': {
    id: 'rgstrtn.address',
    defaultMessage: 'Address',
  },
  'rgstrtn.country': {
    id: 'rgstrtn.country',
    defaultMessage: 'Country',
  },
  'rgstrtn.email': {
    id: 'rgstrtn.email',
    defaultMessage: 'Email',
  },
  'rgstrtn.farm_name': {
    id: 'rgstrtn.farm_name',
    defaultMessage: 'Farm Name',
  },
  'rgstrtn.last_name': {
    id: 'rgstrtn.last_name',
    defaultMessage: 'Last Name',
  },
  'rgstrtn.first_name': {
    id: 'rgstrtn.first_name',
    defaultMessage: 'First Name',
  },
  'rgstrtn.create_username_password': {
    id: 'rgstrtn.create_username_password',
    defaultMessage: 'Create a username & password',
  },
  'rgstrtn.username': {
    id: 'rgstrtn.username',
    defaultMessage: 'Username',
  },
  'rgstrtn.other_details_optional': {
    id: 'rgstrtn.other_details_optional',
    defaultMessage: 'Other details (optional)',
  },
  'rgstrtn.confirm_password': {
    id: 'rgstrtn.confirm_password',
    defaultMessage: 'Confirm Password',
  },
  'rgstrtn.postal_code': {
    id: 'rgstrtn.postal_code',
    defaultMessage: 'Postal Code',
  },
  'rgstrtn.zip_code': {
    id: 'rgstrtn.zip_code',
    defaultMessage: 'Zip Code',
  },
  'rgstrtn.province': {
    id: 'rgstrtn.province',
    defaultMessage: 'Province',
  },
  'rgstrtn.state': {
    id: 'rgstrtn.state',
    defaultMessage: 'State',
  },
  'rgstrtn.email_already_in_use': {
    id: 'rgstrtn.email_already_in_use',
    defaultMessage: 'Email address already in use',
  },
  'rgstrtn.submit': {
    id: 'rgstrtn.submit',
    defaultMessage: 'Submit',
  },
  sending: {
    id: 'sending',
    defaultMessage: 'Sending...',
  },
  email_my_info: {
    id: 'email_my_info',
    defaultMessage: 'Email my info',
  },
  'rgstrtn.create_new_account': {
    id: 'rgstrtn.create_new_account',
    defaultMessage: 'Create new account',
  },
  passwordsDoNotMatch: {
    id: 'hfty.accounts.passwordDoNotMatch',
    defaultMessage: 'Your passwords do not match.',
  },
  passwordTooShort: {
    id: 'passwordTooShort',
    defaultMessage: 'Password must be at least 8 characters.',
  },
  Password: {
    id: 'hfty.accounts.password',
    defaultMessage: 'Password',
  },
  isInvalidZipcode: {
    id: 'isInvalidZipcode',
    defaultMessage: 'Invalid zip code',
  },
  isInvalidEmail: {
    id: 'isInvalidEmail',
    defaultMessage: 'Invalid email address',
  },
  isRequired: {
    id: 'isRequired',
    defaultMessage: 'This field is required.',
  },
  usernameValidText: {
    id: 'usernameValidText',
    defaultMessage: 'Enter a valid username. This value may contain only letters, numbers and @/./+/-/_ characters',
  },
  usernameIsCaseSensitive: {
    id: 'usernameIsCaseSensitive',
    defaultMessage: 'Please note that username is case sensitive.',
  },
  digitOrBlank: {
    id: 'digitOrBlank',
    defaultMessage: 'Please enter digit or leave field blank.',
  },
  passwordCheckListHeader: {
    id: 'passwordCheckListHeader',
    defaultMessage: 'Password must meet the following requirements',
  },
})
